<template>
  <div class="paypal-payment-container">
    <div id="paypal-button-container"></div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';
import { urlGenerator } from '../../Helpers/AxiosHelper'; // Add this import
// Add this near your imports
// OR get it from your environment
const TENANT_BASE_URL = process.env.MIX_APP_URL || window.location.origin;

export default {
  props: {
    amount: { type: Number, required: true },
    currency: { type: String, default: 'EUR' },
    jobSlug: { type: String, required: true },
    applicantId: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      error: null,
      paypal: null
    }
  },
  mounted() {
    this.initPaypal();
  },
  methods: {
    async initPaypal() {
      try {
        const clientId = "Abx_RYZHkX2i1RiJoI4NJVXOJVoeopLnvaOx9Hgsk7Nuri_IV2n4aMHT35b_fsnb4FwHkdfLReB3IVNq";

        this.paypal = await loadScript({
          'client-id': clientId,
          currency: this.currency,
          'disable-funding': 'credit,card'
        });

        this.paypal.Buttons({
          style: {
            layout: 'vertical',
            color: 'blue',
            shape: 'rect',
            label: 'paypal'
          },
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [{
                amount: {
                  value: this.amount.toFixed(2),
                  currency_code: this.currency
                },
                description: `Application Fee - ${this.jobSlug}`,
                custom_id: `applicant_${this.applicantId}`
              }],
              application_context: {
                brand_name: document.title || 'Job Application',
                user_action: 'PAY_NOW',
                return_url: urlGenerator(`${TENANT_BASE_URL}/paypal/return`),
                cancel_url: urlGenerator(`${TENANT_BASE_URL}/paypal/cancel`)
              }
            });
          },
          onApprove: async (data, actions) => {
                this.loading = true;
                try {
                  // First capture the order on client side
                  const details = await actions.order.capture();

                  // Then send to your backend
                  const response = await axios.post(
                      `${TENANT_BASE_URL}/${this.jobSlug}/apply/payment`,
                      {
                        order_id: data.orderID,
                        applicant_id: this.applicantId,
                        capture_details: details // Send the capture details to backend
                      }
                  );

                  if (response.data.status === 'success') {
                    this.$emit('payment-completed', response.data);
                  } else {
                    throw new Error(response.data.message || 'Payment verification failed');
                  }
                } catch (error) {
                  console.error('Payment error:', error);
                  this.handlePaymentError(error);
                } finally {
                  this.loading = false;
                }
              },
          onError: (err) => {
            this.handlePaymentError(err);
          }
        }).render('#paypal-button-container');

      } catch (error) {
        this.handlePaymentError(error);
      }
    },
    handlePaymentError(error) {
      console.error('PayPal Error:', error);
      this.error = error.message || 'Payment initialization failed';
      this.$emit('payment-error', error);
    }
  }
}
</script>

<style scoped>
.paypal-payment-container {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #f9f9f9;
}

.payment-loading {
  text-align: center;
  padding: 20px;
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.alert-danger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  border-radius: 4px;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: inherit;
}

#paypal-button-container {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>